import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, eyebrow, title, testid }) => (
    <Reveal className="mb-12 md:mb-16">
        <div className="flex items-baseline gap-4 mb-4">
            <span className="font-mono text-xs tracking-widest text-oxblood">
                {index}
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate2">
                {eyebrow}
            </span>
        </div>
        <h2
            data-testid={testid}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ink"
        >
            {title}
        </h2>
    </Reveal>
);
